import React from "react";

export function CountryBadge({ country, testid }) {
  const fr = (country || "NL").toUpperCase() === "FR";
  return (
    <span data-testid={testid}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold tracking-wide ring-1 ${fr ? "bg-sky-50 text-sky-700 ring-sky-200" : "bg-orange-50 text-orange-700 ring-orange-200"}`}>
      {fr ? "FR" : "NL"}
    </span>
  );
}
